/* ==========================================================================
   TAMWAJ · عروض الكميات — المنطق
   - يضبط الكمية حسب العرض المختار
   - يحدّث الأسعار عند تغيّر المتغيّر (variant:changed)
   - يطبّق كود الخصم تلقائيًا قبل الإضافة للسلة
   ========================================================================== */
(function () {
  'use strict';

  var ROOT_URL = (window.theme && window.theme.localeRootUrl) || '';
  /* نفس السبب: نكتب AED مباشرة بدل انتظار تصحيح tamwaj-money.js */
  var MONEY_FORMAT = ((window.theme && window.theme.moneyFormat) || '{{amount}}')
    .replace(/Dhs\.?/i, 'AED');

  /* ---------- تنسيق السعر بنفس صيغة المتجر ---------- */
  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || MONEY_FORMAT;

    function defaultTo(n, size) {
      return new Array(Math.max(0, size - String(n).length + 1)).join('0') + n;
    }

    function thousands(number, precision, thousand, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousand = thousand === undefined ? ',' : thousand;
      decimal = decimal === undefined ? '.' : decimal;
      var negative = number < 0 ? '-' : '';
      var base = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(precision), 10));
      var mod = base.length > 3 ? base.length % 3 : 0;
      return negative
        + (mod ? base.substr(0, mod) + thousand : '')
        + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + thousand)
        + (precision ? decimal + defaultTo(Math.abs(number - base).toFixed(precision).slice(2), precision) : '');
    }

    var amount = Number(cents) / 100;
    var match = fmt.match(placeholder);
    if (!match) return fmt;

    switch (match[1]) {
      case 'amount':                             value = thousands(amount, 2); break;
      case 'amount_no_decimals':                 value = thousands(amount, 0); break;
      case 'amount_with_comma_separator':        value = thousands(amount, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(amount, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':   value = thousands(amount, 2, "'", '.'); break;
      case 'amount_with_space_separator':        value = thousands(amount, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(amount, 0, ' ', ','); break;
      default:                                   value = thousands(amount, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- تخزين يصمد عبر التبويبات والزيارات ----------
     نجرّب localStorage ثم sessionStorage ثم الكوكيز — لأن بعض المتصفحات
     (التصفح الخاص، إعدادات الخصوصية) تحجب أحدها دون الآخر.          */
  var STORE_KEY = 'tamwaj_bundles_deadline';

  var Store = {
    get: function (key) {
      try { var a = window.localStorage.getItem(key);   if (a !== null) return a; } catch (e) {}
      try { var b = window.sessionStorage.getItem(key); if (b !== null) return b; } catch (e) {}
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + key + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    },
    set: function (key, value) {
      var v = String(value);
      try { window.localStorage.setItem(key, v); } catch (e) {}
      try { window.sessionStorage.setItem(key, v); } catch (e) {}
      try {
        document.cookie = key + '=' + encodeURIComponent(v) +
          '; max-age=' + (60 * 60 * 24 * 30) + '; path=/; SameSite=Lax';
      } catch (e) {}
    }
  };

  /* ---------- العدّاد التنازلي ----------
     موعد نهاية واحد لكل زائرة، محفوظ على الجهاز. يصمد عبر الريفريش
     والتبويبات وإغلاق المتصفح. إذا انتهى يبقى على 00:00 حتى نهاية
     التصفّح الحالي — ولا يقفز للخلف أمام العميلة — ثم يبدأ موعد جديد
     في أول تحميل تالٍ للصفحة.                                        */
  function startTimer(el, minutes) {
    var valueEl = el.querySelector('[data-tamwaj-timer-value]');
    if (!valueEl) return;

    var duration = Math.max(1, parseInt(minutes, 10) || 15) * 60 * 1000;
    var now = Date.now();
    var deadline = parseInt(Store.get(STORE_KEY), 10);

    // موعد جديد إذا لم يوجد، أو انتهى، أو كان بعيدًا بشكل غير منطقي
    if (!deadline || isNaN(deadline) || deadline <= now || deadline - now > duration) {
      deadline = now + duration;
      Store.set(STORE_KEY, deadline);
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    var interval = setInterval(tick, 1000);

    function tick() {
      var left = deadline - Date.now();
      if (left <= 0) {
        valueEl.textContent = '00:00';
        clearInterval(interval);
        return;
      }
      var total = Math.floor(left / 1000);
      valueEl.textContent = pad(Math.floor(total / 60)) + ':' + pad(total % 60);
    }

    tick();
  }

  /* ---------- جسر Releasit COD Form ----------
     Releasit ينشئ الطلب بنفسه ولا يمرّ على سلة Shopify، فكوكي كود الخصم
     لا يصله. لكنه يقرأ خصمًا ثابتًا من #awesome-quantity-data ويضيفه
     إلى الطلب. نكتب فيه قيمة خصم العرض المختار (بالسنت).            */
  function syncCodDiscount(cents) {
    var el = document.getElementById('awesome-quantity-data');
    if (!el) {
      el = document.createElement('div');
      el.id = 'awesome-quantity-data';
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(el);
    }
    el.setAttribute('data-applied-discount', String(Math.max(0, Math.round(cents))));
  }

  /* Releasit يعرض اسم الخصم حرفيًا "AWESOME QUANTITY DISCOUNT".
     نستبدله بنصّ عربي حتى لا يظهر أي كود أو اسم أجنبي للعميلة. */
  var COD_RAW_LABEL = 'AWESOME QUANTITY DISCOUNT';
  var codLabelWatcherOn = false;

  function watchCodLabel(label) {
    if (codLabelWatcherOn || !label) return;
    codLabelWatcherOn = true;

    var relabel = function () {
      var nodes = document.querySelectorAll(
        '._rsi-modal-discounts-plaque-code, ._rsi-modal-discounts-plaque, ._rsi-modal-discounts-plaques *'
      );
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.children.length === 0 && n.textContent.trim() === COD_RAW_LABEL) {
          n.textContent = label;
        }
      }
    };

    var observer = new MutationObserver(relabel);
    var start = function () {
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      relabel();
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }

  /* ---------- الودجت ---------- */
  function initWidget(root) {
    if (root.dataset.tamwajReady === '1') return;
    root.dataset.tamwajReady = '1';

    var form = root.closest('form[action*="/cart/add"]');
    if (!form) return;

    var tiers;
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
    if (!tiers.length) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var atcButton = form.querySelector('[data-action="add-to-cart"]');
    var hideQty = root.getAttribute('data-hide-quantity') === 'true';
    var showUnit = root.getAttribute('data-show-unit') === 'true';
    var unitLabel = root.getAttribute('data-unit-label') || '';
    var saveLabel = root.getAttribute('data-save-label') || '';
    var codLabel = root.getAttribute('data-cod-label') || '';
    var rounding = root.getAttribute('data-rounding') || 'none';

    /* التقريب مشترك مع سكربت السلة عبر tamwaj-pricing.js */
    function priced(cents) {
      return (window.TamwajPricing && window.TamwajPricing.round)
        ? window.TamwajPricing.round(cents, rounding)
        : Math.round(cents);
    }

    watchCodLabel(codLabel);

    if (hideQty) {
      var qtyWrapper = form.querySelector('.ProductForm__QuantitySelector');
      if (qtyWrapper) qtyWrapper.classList.add('TamwajHiddenQty');
    }

    // السعر الحالي للمتغيّر المختار
    var current = {
      price: parseInt(root.getAttribute('data-price'), 10) || 0,
      compare: parseInt(root.getAttribute('data-compare'), 10) || 0
    };

    /* لا نختار عرضًا نيابةً عن العميلة: الاختيار قرارها، وهو أول
       التزام صغير منها — والالتزام الأول يرفع احتمال الشراء. */
    function selectedTier() {
      var checked = root.querySelector('.TamwajBundle__Input:checked');
      if (!checked) return null;
      return tiers[parseInt(checked.value, 10)] || null;
    }

    function renderPrices() {
      var base = current.price;
      var baseCompare = current.compare > base ? current.compare : base;

      tiers.forEach(function (tier, i) {
        var item = root.querySelector('[data-tamwaj-tier="' + i + '"]');
        if (!item) return;

        var qty = tier.qty;
        var total = priced(base * qty * (1 - (tier.discount || 0) / 100));
        var compareTotal = Math.round(baseCompare * qty);

        var priceEl = item.querySelector('[data-tamwaj-price]');
        var compareEl = item.querySelector('[data-tamwaj-compare]');
        var unitEl = item.querySelector('[data-tamwaj-unit]');
        var saveEl = item.querySelector('[data-tamwaj-save]');

        if (priceEl) priceEl.textContent = formatMoney(total);
        if (compareEl) compareEl.textContent = compareTotal > total ? formatMoney(compareTotal) : '';

        if (unitEl && showUnit && qty > 1) {
          unitEl.textContent = formatMoney(Math.round(total / qty)) + ' ' + unitLabel;
        } else if (unitEl) {
          unitEl.textContent = '';
        }

        if (saveEl) {
          var saved = compareTotal - total;
          if (saveLabel && saved > 0) {
            saveEl.textContent = saveLabel.replace('{amount}', formatMoney(saved));
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
      });

      syncButton();
    }

    function syncButton() {
      var tier = selectedTier();

      if (!tier) {
        /* بلا اختيار: كمية واحدة، بلا كود ولا خصم عند الاستلام */
        if (qtyInput) qtyInput.value = 1;
        form.setAttribute('data-tamwaj-code', '');
        syncCodDiscount(0);
        broadcast(null);
        return;
      }

      if (qtyInput) qtyInput.value = tier.qty;
      form.setAttribute('data-tamwaj-code', tier.code || '');

      // خصم فورم الدفع عند الاستلام (Releasit) — بالسنت
      var discountCents = (current.price * tier.qty) - priced(current.price * tier.qty * (1 - (tier.discount || 0) / 100));
      syncCodDiscount(discountCents);

      broadcast(tier);

      // تحديث السعر داخل زر الإضافة إن كان الثيم يعرضه
      if (atcButton) {
        var buttonPrice = atcButton.querySelector('[data-money-convertible]');
        if (buttonPrice) {
          var total = priced(current.price * tier.qty * (1 - (tier.discount || 0) / 100));
          buttonPrice.textContent = formatMoney(total);
        }
      }
    }

    /* نبثّ حالة العرض المختار ليعرضها شريط الشراء الثابت */
    function broadcast(tier) {
      var baseCompare = current.compare > current.price ? current.compare : current.price;

      if (!tier) {
        document.dispatchEvent(new CustomEvent('tamwaj:bundle:changed', {
          detail: {
            qty: 1, name: '', total: current.price, compare: baseCompare,
            saved: baseCompare - current.price,
            totalText: formatMoney(current.price),
            compareText: baseCompare > current.price ? formatMoney(baseCompare) : '',
            savedText: ''
          }
        }));
        return;
      }

      var total = priced(current.price * tier.qty * (1 - (tier.discount || 0) / 100));
      var compare = Math.round(baseCompare * tier.qty);
      var saved = compare - total;

      document.dispatchEvent(new CustomEvent('tamwaj:bundle:changed', {
        detail: {
          qty: tier.qty,
          name: tier.name || '',
          total: total,
          compare: compare,
          saved: saved,
          totalText: formatMoney(total),
          compareText: compare > total ? formatMoney(compare) : '',
          savedText: (saveLabel && saved > 0) ? saveLabel.replace('{amount}', formatMoney(saved)) : ''
        }
      }));
    }

    root.addEventListener('change', function (event) {
      if (event.target.classList.contains('TamwajBundle__Input')) syncButton();
    });

    // تحديث الأسعار عند تغيير اللون/المقاس
    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var origin = event.target;
      if (origin && origin.nodeType === 1 && !origin.contains(form) && !form.contains(origin)) return;
      current.price = variant.price;
      current.compare = variant.compare_at_price || 0;
      setTimeout(renderPrices, 0); // بعد ما ينتهي الثيم من تحديثاته
    });

    /* ---------- لماذا لا نطلب كود خصم شوبيفاي ----------
       كان الزر يجلب /discount/CODE قبل الإضافة، فيخصم شوبيفاي من
       السلة. لكن Releasit ينشئ الطلب من الأسعار الأصلية ولا يمرّ
       على سلة شوبيفاي — فيصير خصمان: واحد في السلة وواحد في
       النموذج، ورقمان مختلفان أمام العميلة.

       كل الطلبات تمرّ على الدفع عند الاستلام، فمحرّك الخصم واحد:
       جدول العروض. أما الكود فلا دور له، وإبقاؤه كان يفسد الأرقام. */

    /* ---------- لا طلب قبل اختيار عدد القطع ----------
       يغطّي زر Releasit وزر الإضافة للسلة وشريط الشراء الثابت.
       المستمع على document وفي طور الالتقاط، فيسبق أي مستمع
       على الزر نفسه ويمنع فتح النموذج قبل الاختيار.            */
    function nudge() {
      root.classList.remove('TamwajBundles--nudge');
      void root.offsetWidth;                    // إعادة تشغيل الحركة
      root.classList.add('TamwajBundles--nudge');
      try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { root.scrollIntoView(); }
      var first = root.querySelector('.TamwajBundle__Input');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }

    document.addEventListener('click', function (event) {
      if (selectedTier()) return;
      var t = event.target;
      if (!t || !t.closest) return;
      if (!t.closest('._rsi-buy-now-button') &&
          !t.closest('[data-action="add-to-cart"]') &&
          !t.closest('.TamwajSticky__Button')) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      nudge();
    }, true);

    root.addEventListener('change', function (event) {
      if (event.target.classList.contains('TamwajBundle__Input')) {
        root.classList.remove('TamwajBundles--nudge');
      }
    });

    // العدّاد
    var timer = root.querySelector('[data-tamwaj-timer]');
    if (timer) startTimer(timer, timer.getAttribute('data-minutes'));

    root.classList.add('TamwajBundles--active');
    renderPrices();
  }

  function initAll() {
    document.querySelectorAll('.TamwajBundles').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // إعادة التهيئة بعد تحديث القسم في المحرّر
  document.addEventListener('shopify:section:load', initAll);
})();
